import type { Movie } from "@/types/content";

export const movies: Movie[] = [
  {
    id: "white-porcelain",
    title: "白瓷之隙",
    year: 2023,
    genre: "家庭伦理",
    tags: ["家庭", "代际", "器物", "和解"],
    rating: 9.1,
    duration: 118,
    director: "河濑一成",
    cast: ["宫本澄", "白石遥", "大谷凉"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20art%20of%20a%20cracked%20white%20porcelain%20bowl%20resting%20on%20a%20dark%20wooden%20table%20in%20a%20quiet%20Japanese%20dining%20room%2C%20thin%20morning%20light%20through%20paper%20shoji%20screens%2C%20muted%20navy%20and%20warm%20sepia%20palette%2C%20minimal%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-01&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=moody%20cinematic%20wide%20shot%20of%20a%20traditional%20Japanese%20dining%20room%20at%20dawn%2C%20low%20wooden%20table%2C%20cracked%20white%20ceramic%20bowl%2C%20soft%20light%20through%20shoji%20screens%2C%20deep%20navy%20shadows%20and%20warm%20amber%20highlights%2C%20empty%20chairs%2C%20editorial%20film%20still%2C%20no%20text&width=1600&height=900&seq=hero-01&orientation=landscape",
    summary: "一只裂开的白瓷碗，牵出三代人沉默四十年的家庭秘密。",
    plot:
      "长女澄子在母亲葬礼后回到老宅，发现厨房里那只缺了口的白瓷碗被仔细收进木箱。她与弟弟、以及多年不往来的父亲围绕这只碗的来历展开争执，逐渐拼出母亲年轻时的一段选择。全片几乎不出现激烈冲突，所有情绪都藏在餐桌、器物与停顿里。",
    analysis: [
      "影片把「器物」当作伦理关系的载体：白瓷碗既是母亲留下的证据，也是家庭内部无法说出口的亏欠。导演河濑一成刻意不给裂缝特写，而是让它反复出现在画面边缘，让观众自己在日常中意识到破损的存在。",
      "叙事结构上，三个子女分别代表三种面对家族秘密的态度——追问、回避与承担。影片并未给出道德裁决，而是把选择权交回观众：理解并不等于原谅，但理解是继续共同生活的前提。",
      "值得关注的是声音设计。全片没有配乐，只有水声、碗碟碰撞声与远处的电车。这种处理让「家」从抽象概念回到具体空间，也让伦理议题落在可以触摸的日常之上。",
    ],
    featured: true,
    updatedAt: "2025-09-18",
  },
  {
    id: "letters-in-rain",
    title: "雨夜的家书",
    year: 2019,
    genre: "伦理片",
    tags: ["亲情", "书信", "离别", "昭和"],
    rating: 8.8,
    duration: 106,
    director: "森下千秋",
    cast: ["松永真纪", "藤井川", "小野原透"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20handwritten%20letter%20on%20a%20wooden%20desk%20beside%20a%20rain%20streaked%20window%20at%20night%2C%20soft%20lamp%20glow%2C%20deep%20blue%20shadows%2C%20Japanese%20domestic%20interior%2C%20minimal%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-02&orientation=portrait",
    summary: "一封迟到二十年的家书，让留在故乡的人重新理解了离开的人。",
    plot:
      "在东京做校对工作的女儿收到一叠旧信，寄件人是二十年前离家出走的父亲。信里没有辩解，只有琐碎的天气与菜价。她带着信回到海边小镇，与照顾祖母多年的姑姑一同读完这些文字，也读完了两代人对「留下」与「离开」的不同理解。",
    analysis: [
      "《雨夜的家书》最动人的地方在于它拒绝和解的戏剧性。父女始终没有见面，影片把全部情感放进文本与朗读之中，让缺席成为真正的主角。",
      "伦理层面上，影片讨论的是照护责任如何在家庭成员之间被默认为「某一个人的义务」。姑姑这个角色承担了全部日常照护，却在遗产与记忆里几乎不被提起，这是影片最锋利的一笔。",
    ],
    updatedAt: "2025-08-02",
  },
  {
    id: "silent-testimony",
    title: "静默的证词",
    year: 2021,
    genre: "社会伦理",
    tags: ["法庭", "职业伦理", "真相", "群像"],
    rating: 8.6,
    duration: 124,
    director: "石川吾郎",
    cast: ["大谷凉", "水野沙耶", "宫本澄"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20an%20empty%20courtroom%20bench%20with%20hard%20light%20cutting%20through%20window%20blinds%2C%20cool%20grey%20blue%20tones%2C%20dust%20in%20the%20air%2C%20austere%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-03&orientation=portrait",
    summary: "一名翻译在法庭上选择沉默，却让整起案件的天平开始倾斜。",
    plot:
      "地方法院审理一起工厂事故案，法庭翻译美咲发现被告的证词在两种语言之间存在无法弥合的偏差。她可以选择照本宣科完成工作，也可以要求重新确认。她的犹豫牵动了法官、律师与受害者家属各自的立场。",
    analysis: [
      "影片把伦理困境放在「专业角色」之上：翻译的职责是忠实，但忠实于字面，可能意味着对事实的背叛。这种职业伦理与公共正义之间的张力，是全片的核心。",
      "导演用大量固定机位和对称构图强调制度感，人物的微小动作因此被放大。结尾没有宣判结果，只留下美咲走出法院时的一段长镜头，把判断交给观众。",
    ],
    updatedAt: "2025-07-21",
  },
  {
    id: "after-spring-equinox",
    title: "春分之后",
    year: 2018,
    genre: "伦理片",
    tags: ["婚姻", "中年", "选择", "四季"],
    rating: 8.4,
    duration: 112,
    director: "津岛和也",
    cast: ["松永真纪", "小野原透", "白石遥"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20two%20teacups%20on%20a%20low%20wooden%20table%20with%20spring%20light%20and%20falling%20cherry%20petals%20outside%20a%20window%2C%20soft%20cream%20and%20muted%20rose%20palette%2C%20quiet%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-04&orientation=portrait",
    summary: "结婚十五年的夫妻，在春分这天第一次认真谈论「要不要继续」。",
    plot:
      "一对中年夫妻在春分假期回到乡下老屋整理旧物。没有争吵，也没有第三者，只是两个人在同一屋檐下发现彼此已经很久没有真正对话。影片用一天一夜的时间，让所有被搁置的问题缓慢浮出水面。",
    analysis: [
      "这是一部关于「日常伦理」的作品：没有极端情境，只有持续的选择。影片把婚姻理解为一种需要不断续签的契约，而非一次性的承诺。",
      "春分作为片名具有明确的结构意义——昼夜等长，也意味着平衡是暂时的，之后必然偏向某一侧。结尾两人并肩走在田埂上，谁也没有给出答案，但观众能感到某种平衡已经重新建立。",
    ],
    updatedAt: "2025-06-30",
  },
  {
    id: "borrowed-name",
    title: "借来的名字",
    year: 2022,
    genre: "社会伦理",
    tags: ["身份", "移民", "户籍", "尊严"],
    rating: 8.9,
    duration: 130,
    director: "河濑一成",
    cast: ["藤井川", "水野沙耶", "大谷凉"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20name%20seal%20and%20old%20identity%20documents%20spread%20on%20tatami%20at%20dusk%2C%20warm%20low%20light%2C%20deep%20shadows%2C%20muted%20brown%20and%20navy%20palette%2C%20minimal%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-05&orientation=portrait",
    summary: "为了留在日本，他借用了一个死者的名字，也借走了另一个人的人生。",
    plot:
      "在关西小城打工的陈姓男子，因证件问题被迫使用一位已故日本老人的身份生活。二十年过去，他成了社区里受人尊敬的木工，直到老人的孙女前来整理遗物。两个被同一个名字牵连的陌生人，必须决定如何面对这段历史。",
    analysis: [
      "影片讨论的是「制度性尊严」：当一个人必须借用他人身份才能获得基本生活权利时，伦理问题就不只在个人，而在规则本身。",
      "导演避免把主角塑造成受害者或骗子。他勤劳、克制、也做出过自私的决定。影片的复杂性正来自这种不完全正当的处境，让观众难以轻易站队。",
      "结尾的遗物整理场景极具力量：名字归还，但共同生活的记忆无法归还。",
    ],
    updatedAt: "2025-09-05",
  },
  {
    id: "confession-by-the-sea",
    title: "海边的告解",
    year: 2020,
    genre: "伦理片",
    tags: ["救赎", "悔意", "海边", "独白"],
    rating: 8.7,
    duration: 99,
    director: "森下千秋",
    cast: ["小野原透", "松永真纪", "水野沙耶"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20lone%20figure%20silhouette%20standing%20on%20a%20winter%20seaside%20at%20dusk%2C%20grey%20blue%20waves%2C%20pale%20sky%2C%20vast%20negative%20space%2C%20minimal%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-06&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20winter%20Japanese%20seaside%20at%20dusk%20with%20a%20solitary%20figure%20walking%20along%20the%20waterline%2C%20desaturated%20blue%20grey%20sea%2C%20dark%20clouds%2C%20muted%20amber%20horizon%20light%2C%20editorial%20film%20still%2C%20no%20text&width=1600&height=900&seq=hero-02&orientation=landscape",
    summary: "一个无法被法律审判的过错，只能在海边一遍遍说给潮水听。",
    plot:
      "退休教师吉冈每周三都会去海边，对着海水讲述同一件事：三十年前，他因为一次沉默，让一名学生独自承担了不该承担的后果。直到那名学生以成年人的身份出现在他面前。",
    analysis: [
      "影片的核心命题是「无法偿还的亏欠」。它不提供赦免，也不把忏悔浪漫化，而是让两个人坐在同一张长椅上，各自承受记忆的重量。",
      "海在片中既是见证者，也是消解者。潮水反复抹平脚印的意象，暗示时间并不能真正解决伦理问题，只能让人学会与其共处。",
    ],
    featured: true,
    updatedAt: "2025-05-14",
  },
  {
    id: "three-under-the-eaves",
    title: "檐下三人",
    year: 2017,
    genre: "家庭伦理",
    tags: ["重组家庭", "日常", "边界", "屋檐"],
    rating: 8.2,
    duration: 105,
    director: "石川吾郎",
    cast: ["白石遥", "大谷凉", "藤井川"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20three%20pairs%20of%20shoes%20neatly%20arranged%20at%20a%20Japanese%20genkan%20entrance%20with%20warm%20indoor%20light%2C%20wooden%20floor%2C%20muted%20amber%20and%20deep%20brown%20palette%2C%20minimal%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-07&orientation=portrait",
    summary: "三个没有血缘关系的人，在同一屋檐下学习如何成为家人。",
    plot:
      "再婚的两人带着各自的孩子搬进同一栋房子。鞋柜上摆着三双尺码不同的鞋，门口的地垫每天被踩过三次。影片用一年四季的早餐、晾衣与争吵，呈现一个重组家庭如何在细小的摩擦里建立新的秩序。",
    analysis: [
      "影片对「家人」的定义是行为性的，而非血缘性的：一起吃饭、记得对方的忌口、在雨天收衣服。这些重复动作构成了伦理关系的实际内容。",
      "值得称道的是影片没有美化重组家庭，孩子的敌意、成人的疲惫都被如实呈现。正因如此，最后的平静才显得可信。",
    ],
    updatedAt: "2025-04-08",
  },
  {
    id: "glasshouse-winter",
    title: "玻璃温室的冬天",
    year: 2024,
    genre: "伦理剧",
    tags: ["都市", "孤独", "照料", "植物"],
    rating: 8.5,
    duration: 96,
    director: "津岛和也",
    cast: ["水野沙耶", "宫本澄", "小野原透"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20an%20old%20glass%20greenhouse%20covered%20with%20frost%20at%20winter%20dawn%2C%20green%20plants%20inside%2C%20condensation%20on%20panes%2C%20cool%20teal%20and%20soft%20amber%20light%2C%20quiet%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-08&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20inside%20a%20foggy%20old%20glass%20greenhouse%20in%20winter%20with%20rows%20of%20green%20plants%20and%20frosted%20panes%2C%20diffused%20cold%20light%2C%20deep%20navy%20shadows%2C%20warm%20lantern%20glow%20in%20the%20distance%2C%20editorial%20film%20still%2C%20no%20text&width=1600&height=900&seq=hero-03&orientation=landscape",
    summary: "她替陌生人照顾一整个冬天的植物，也替自己找回了一点生活。",
    plot:
      "失业的园艺师受雇照看郊区一栋无人居住的温室。雇主从未露面，只通过留言交代浇水与温度。整个冬天，她与植物、与留言、与偶尔来访的邻居建立起一种奇特的联系。",
    analysis: [
      "影片讨论「照料陌生人」的伦理意义。照料是一种不对等的关系，被照料者甚至不知道自己被照料着，而这种无名性恰恰让行为本身变得纯粹。",
      "温室的玻璃是重要的视觉隐喻：透明却隔绝，既能看见外面的城市，也无法真正进入。这与当代都市人的孤独状态高度契合。",
    ],
    updatedAt: "2025-09-22",
  },
  {
    id: "silent-thanks",
    title: "无声的谢意",
    year: 2016,
    genre: "伦理片",
    tags: ["师生", "校园", "沉默", "成长"],
    rating: 8.0,
    duration: 102,
    director: "森下千秋",
    cast: ["藤井川", "白石遥", "松永真纪"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20an%20empty%20Japanese%20classroom%20with%20a%20clean%20blackboard%20and%20afternoon%20sunlight%20falling%20across%20desks%2C%20warm%20dusty%20light%2C%20muted%20wood%20and%20cream%20palette%2C%20minimal%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-09&orientation=portrait",
    summary: "一个从未说过谢谢的学生，用二十年时间写完了这句话。",
    plot:
      "乡村中学的代课老师在离职前，留下了一封没有寄出的信。二十年后，当年最沉默的学生成为教师，回到同一间教室。两代人的教育理想与现实的妥协，在黑板前交汇。",
    analysis: [
      "影片的伦理讨论围绕「教育的责任边界」展开：老师能改变什么，又不该承担什么。它拒绝把教师神化，也拒绝把结构性问题归咎于个人。",
      "全片最克制的一场戏是结尾——新教师擦掉黑板上的字，重新写下一行。没有台词，但传承的意思已经完整。",
    ],
    updatedAt: "2025-03-19",
  },
  {
    id: "seventh-move",
    title: "第七次搬家",
    year: 2022,
    genre: "伦理剧",
    tags: ["孤独", "都市", "租房", "漂泊"],
    rating: 8.3,
    duration: 94,
    director: "河濑一成",
    cast: ["大谷凉", "水野沙耶", "小野原透"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20stacked%20cardboard%20moving%20boxes%20in%20an%20empty%20apartment%20with%20late%20afternoon%20light%20through%20a%20bare%20window%2C%20dust%20motes%2C%20muted%20grey%20blue%20and%20cardboard%20brown%20palette%2C%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-10&orientation=portrait",
    summary: "第七次搬家时，她终于决定留下一件带不走的东西。",
    plot:
      "三十四岁的派遣职员第七次搬家。每搬一次，她就丢掉一批东西，直到行李箱里只剩下必需品。在新公寓的第一夜，她听见隔壁传来的生活声，第一次意识到自己已经很久没有被人记住。",
    analysis: [
      "影片用「丢弃」讨论当代人的伦理空缺：当一个人不断削减与世界的联系，她对他人的责任也随之消失。这不是道德批判，而是一种社会观察。",
      "大量静止长镜头和空旷的室内构图，让观众直接感受到空间的空。结尾她主动敲响邻居的门，是全片唯一一次向外的动作。",
    ],
    updatedAt: "2025-08-16",
  },
  {
    id: "mother-in-mirror",
    title: "镜中的母亲",
    year: 2021,
    genre: "家庭伦理",
    tags: ["代际", "记忆", "母女", "照护"],
    rating: 9.0,
    duration: 121,
    director: "津岛和也",
    cast: ["松永真纪", "宫本澄", "白石遥"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20an%20old%20oval%20mirror%20in%20a%20dim%20Japanese%20hallway%20reflecting%20a%20warm%20lamp%20and%20a%20woman%20silhouette%2C%20deep%20brown%20and%20muted%20amber%20palette%2C%20minimal%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-11&orientation=portrait",
    summary: "当母亲开始忘记她，女儿必须重新决定自己是谁。",
    plot:
      "母亲被诊断为早期认知障碍后，女儿回到家中承担照护。随着记忆一天天流失，母亲开始把女儿认作年轻时的自己。这种错认让女儿第一次听见母亲从未说过的心里话。",
    analysis: [
      "照护伦理在本片中被具体化为「谁有权替另一个人记住」。女儿既是照护者，也是记录者，她的叙述决定了母亲将以何种形象留存。",
      "影片没有回避照护的消耗：疲惫、怨怼、愧疚同时存在。它提醒观众，伦理不是崇高的选择，而是每天都要重新做一遍的琐事。",
      "镜子这一意象贯穿全片，既指记忆的映照，也指代际之间无法真正重合的自我。",
    ],
    updatedAt: "2025-09-12",
  },
  {
    id: "midnight-clinic",
    title: "深夜诊疗室",
    year: 2023,
    genre: "伦理剧",
    tags: ["医疗", "职业伦理", "夜班", "信任"],
    rating: 8.4,
    duration: 108,
    director: "石川吾郎",
    cast: ["水野沙耶", "藤井川", "大谷凉"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20quiet%20small%20clinic%20corridor%20at%20night%20with%20a%20warm%20ceiling%20light%20and%20one%20closed%20door%2C%20deep%20green%20grey%20and%20amber%20palette%2C%20sterile%20calm%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-12&orientation=portrait",
    summary: "深夜诊所里，每一个决定都没有标准答案。",
    plot:
      "一家位于居民区的夜间诊所，医生与护士在有限条件下接待各式各样的病人。一次拒绝出诊、一次超范围用药、一次替病人隐瞒，让几个人的人生轨迹发生偏移。",
    analysis: [
      "影片以单元剧结构讨论医疗伦理，但所有故事都指向同一个问题：在资源有限时，如何公平地分配注意力与信任。",
      "诊所在视觉上被处理成一个中介空间——既不是家的私密，也不是医院的制度，人在其中暴露得最为真实。",
    ],
    updatedAt: "2025-07-03",
  },
  {
    id: "beyond-the-paper-door",
    title: "纸门另一边",
    year: 2015,
    genre: "伦理片",
    tags: ["邻里", "窥视", "边界", "昭和"],
    rating: 7.8,
    duration: 97,
    director: "森下千秋",
    cast: ["小野原透", "松永真纪", "宫本澄"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20paper%20shoji%20door%20with%20a%20soft%20human%20silhouette%20shadow%20cast%20on%20it%20from%20warm%20lamp%20light%20inside%2C%20dark%20wooden%20room%2C%20muted%20amber%20and%20charcoal%20palette%2C%20minimal%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-13&orientation=portrait",
    summary: "一墙之隔的生活声，让独居老人重新面对自己的边界。",
    plot:
      "昭和末年的老旧长屋，独居老人每天通过纸门后的声音判断邻居一家的生活。当隔壁传来异常动静，他在「不该干涉」与「不能不管」之间反复犹豫。",
    analysis: [
      "影片精准捕捉了邻里伦理的微妙之处：关心与侵入只有一线之隔。老人的犹豫本身就构成了对他人边界的尊重。",
      "纸门作为核心意象，既是物理隔断，也是社会规范的象征——它薄得能听见一切，却厚得让人不敢推开。",
    ],
    updatedAt: "2025-02-11",
  },
  {
    id: "platform-homeward",
    title: "归途的站台",
    year: 2019,
    genre: "伦理片",
    tags: ["乡土", "返乡", "亲情", "铁道"],
    rating: 8.6,
    duration: 113,
    director: "河濑一成",
    cast: ["藤井川", "白石遥", "小野原透"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20small%20rural%20Japanese%20train%20platform%20at%20dusk%20with%20an%20empty%20bench%20and%20overgrown%20grass%2C%20warm%20fading%20light%2C%20muted%20green%20and%20rust%20palette%2C%20nostalgic%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-14&orientation=portrait",
    summary: "一座即将停用的小站，成了父子之间最后的谈判桌。",
    plot:
      "因为线路停运，离乡多年的儿子被迫回到小镇处理老宅。父亲坚持留下，儿子坚持接他去东京。两人在站台等最后一班车的时间里，把二十年的沉默一句句说完。",
    analysis: [
      "影片把「返乡」处理成一次伦理对话，而不是怀旧消费。它承认离开有其正当性，也承认留下需要被看见。",
      "站台的时间感非常精确：列车时刻表成为倒计时，人物的每句话都带着「来不及了」的重量。",
    ],
    updatedAt: "2025-06-06",
  },
  {
    id: "backlit-dining-table",
    title: "逆光的餐桌",
    year: 2024,
    genre: "伦理剧",
    tags: ["婚姻", "沟通", "都市", "沉默"],
    rating: 8.9,
    duration: 110,
    director: "津岛和也",
    cast: ["宫本澄", "大谷凉", "水野沙耶"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20an%20empty%20dining%20table%20backlit%20by%20a%20large%20window%20at%20late%20afternoon%2C%20two%20chairs%2C%20long%20shadows%20on%20the%20floor%2C%20muted%20navy%20and%20warm%20cream%20palette%2C%20minimal%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-15&orientation=portrait",
    summary: "他们每天同桌吃饭，却已经三年没有说过一句真话。",
    plot:
      "一对都市夫妻维持着体面的生活，直到妻子在一次体检后决定辞职。丈夫试图用理性说服她，却发现两人对「共同生活」的理解早已不同。",
    analysis: [
      "影片的对话密度极高，但真正重要的信息都藏在停顿与视线回避里。导演把家庭空间拍成了一个谈判现场。",
      "逆光既是摄影手法，也是关系隐喻：彼此只能看见轮廓，看不清对方的表情。结尾灯被打开，意味着对话终于开始。",
    ],
    featured: true,
    updatedAt: "2025-09-28",
  },
  {
    id: "season-of-cicadas",
    title: "蝉鸣时节",
    year: 2009,
    genre: "青春伦理",
    tags: ["青春", "校园", "夏天", "选择"],
    rating: 7.6,
    duration: 92,
    director: "石川吾郎",
    cast: ["白石遥", "松永真纪", "藤井川"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20sunlit%20Japanese%20school%20gate%20in%20midsummer%20with%20green%20trees%20and%20empty%20bicycle%20racks%2C%20bright%20hazy%20light%2C%20muted%20green%20and%20warm%20yellow%20palette%2C%20nostalgic%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-16&orientation=portrait",
    summary: "那个夏天，所有人都在替别人做决定。",
    plot:
      "三名高三学生在升学与家庭期待之间摇摆。一次冲动的顶替事件，让他们的友谊出现裂痕。多年后回望，他们才明白当时最缺的不是勇气，而是被认真询问的机会。",
    analysis: [
      "影片讨论青少年伦理中的一个关键问题：当成年人以「为你好」代替询问，少年人就失去了练习选择的机会。",
      "蝉鸣声贯穿全片，既是夏天的背景音，也暗示一种短暂而密集的成长状态。",
    ],
    updatedAt: "2025-01-24",
  },
  {
    id: "testimony-of-the-mountain",
    title: "山的证言",
    year: 2013,
    genre: "社会伦理",
    tags: ["乡村", "土地", "共同体", "开发"],
    rating: 8.1,
    duration: 119,
    director: "河濑一成",
    cast: ["小野原透", "宫本澄", "藤井川"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20misty%20mountain%20terraced%20fields%20in%20a%20small%20Japanese%20village%20at%20dawn%2C%20stone%20walls%2C%20soft%20fog%2C%20muted%20green%20and%20grey%20blue%20palette%2C%20serene%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-17&orientation=portrait",
    summary: "一项开发计划进山，村民必须在补偿与故乡之间做选择。",
    plot:
      "观光开发计划进入山村，村民被要求签字同意征用祖辈耕作的土地。反对者与支持者各有理由，一场关于土地、记忆与生存的争论在村落内部展开。",
    analysis: [
      "影片拒绝把乡村浪漫化。它清楚呈现了留乡者的经济困境，也呈现了土地对身份认同的意义，让「发展」与「守护」都获得充分的论据。",
      "山的镜头始终高于人，构成一种沉默的证言视角：人的争论会结束，土地会继续存在。",
    ],
    updatedAt: "2025-04-26",
  },
  {
    id: "words-i-never-said",
    title: "我不曾说过的话",
    year: 2020,
    genre: "家庭伦理",
    tags: ["沟通", "父子", "失去", "遗物"],
    rating: 8.8,
    duration: 104,
    director: "森下千秋",
    cast: ["藤井川", "大谷凉", "松永真纪"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20two%20wooden%20chairs%20facing%20each%20other%20across%20a%20small%20table%20with%20an%20old%20telephone%2C%20dim%20warm%20interior%2C%20deep%20shadows%2C%20muted%20brown%20and%20navy%20palette%2C%20minimal%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-18&orientation=portrait",
    summary: "父亲去世后，儿子在旧电话的留言里听见了自己的一生。",
    plot:
      "父亲去世后，儿子在整理旧物时发现一台老式电话留言机，里面存着二十年间的留言。他逐条听完，才发现父亲一直在用他不知道的方式关心着他。",
    analysis: [
      "影片让「倾听」成为伦理行为本身。儿子此前从未真正听过父亲说话，而留言机提供了迟到的机会。",
      "声音是这部作品的主角：呼吸、迟疑、挂断前的停顿，都比台词更有说服力。",
    ],
    updatedAt: "2025-08-27",
  },
  {
    id: "the-blank-page",
    title: "空白的一页",
    year: 2018,
    genre: "伦理片",
    tags: ["记忆", "记录", "老年", "书写"],
    rating: 8.2,
    duration: 101,
    director: "津岛和也",
    cast: ["松永真纪", "小野原透", "水野沙耶"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20an%20open%20blank%20notebook%20with%20a%20fountain%20pen%20on%20a%20wooden%20writing%20desk%20in%20soft%20window%20light%2C%20quiet%20Japanese%20study%2C%20muted%20cream%20and%20deep%20green%20palette%2C%20minimal%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-19&orientation=portrait",
    summary: "一位老编辑决定在遗忘之前，把最后一页写完。",
    plot:
      "从业四十年的老编辑退休后开始写回忆录，却发现自己对最重要的那几年几乎没有记忆。他走访旧同事与作者，试图拼出一个完整的版本，也发现每个人记住的都不一样。",
    analysis: [
      "影片讨论记忆的伦理：当个人叙述与他人叙述冲突，谁有资格定义过去？它没有给出答案，而是让多种版本并置。",
      "空白的笔记本在片中反复出现，象征记忆的缺口，也象征书写本身的可能性——空白不是失败，而是尚未决定。",
    ],
    updatedAt: "2025-05-30",
  },
  {
    id: "promise-under-the-lamp",
    title: "灯下的约定",
    year: 2025,
    genre: "伦理剧",
    tags: ["亲情", "约定", "家族", "新作"],
    rating: 8.7,
    duration: 115,
    director: "石川吾郎",
    cast: ["宫本澄", "白石遥", "大谷凉"],
    country: "日本（虚构）",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20warm%20lantern%20glowing%20beside%20a%20small%20Japanese%20family%20altar%20corner%2C%20wooden%20frame%20and%20incense%20smoke%2C%20deep%20navy%20shadows%2C%20amber%20light%2C%20minimal%20editorial%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=mv-20&orientation=portrait",
    summary: "祖母留下的一个约定，让分散的一家人重新回到同一张桌前。",
    plot:
      "祖母去世前留下一句话：每年灯会之夜，家里必须有人点亮门口的那盏灯。三年后，四散的家人为了这个约定陆续回到老宅，各自带着无法说出口的近况。",
    analysis: [
      "作为新作，《灯下的约定》把伦理落到「仪式」上：一个看似形式的约定，成为维系家庭的最低限度共识。",
      "影片对团聚不做煽情处理，反而强调尴尬与疏离。正因如此，最后那盏灯亮起时才具有真正的分量。",
    ],
    updatedAt: "2025-10-10",
  },
];